export default __webpack_public_path__ + "static/media/avatar1.5c8ddd5a.svg";